import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/obito`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        cidadao: {
            autocomplete: (queryParms = {}) => {
                return repository.get(`${baseUrl}/autocomplete-cidadao?${urlUtil.serialize(queryParms)}`)
            },
        },
        cid: {
            autocomplete: (queryParms = {}) => {
                return repository.get(`${baseUrl}/autocomplete-cid?${urlUtil.serialize(queryParms)}`)
            },
        },
        usuario: {
            autocomplete: (queryParms = {}) => {
                return repository.get(`${baseUrl}/autocomplete-usuario?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}